var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightDomainAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.952 0c2.732 0 4.953 2.222 4.953 4.953 0 2.66-2.106 4.836-4.738 4.948l-.215.005-.215-.005C2.105 9.79 0 7.613 0 4.953 0 2.222 2.221 0 4.952 0zm0 1.602l-.184.005c-1.762.096-3.167 1.56-3.167 3.346 0 1.847 1.504 3.35 3.351 3.35 1.848 0 3.352-1.503 3.352-3.35 0-1.785-1.406-3.25-3.168-3.346l-.184-.005z",
    transform: "translate(-670.000000, -53.000000) translate(670.184900, 53.789400) translate(4.302100, 2.013200)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18.509 19.427v1.6H0v-1.353c.043-3.662 2.24-6.92 5.544-8.37l.141-.062.12.098c.335.277.705.514 1.1.705l.559.27-.589.193c-2.912.956-4.987 3.57-5.244 6.628l-.019.29h15.284l-.019-.298c-.251-2.963-2.212-5.51-4.988-6.531l-.255-.089-.589-.193.558-.27c.396-.19.766-.428 1.102-.705l.119-.098.14.062c3.304 1.451 5.502 4.709 5.543 8.37l-.008-.248.007.247-.007-.247h.01z",
    transform: "translate(-670.000000, -53.000000) translate(670.184900, 53.789400)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#368FEF",
    d: "M11.067 18.664L7.443 18.664 8.651 13.429 9.859 13.429z",
    transform: "translate(-670.000000, -53.000000) translate(670.184900, 53.789400)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeWidth: 0.5,
    d: "M11.067 18.664L7.443 18.664 8.651 13.429 9.859 13.429z",
    transform: "translate(-670.000000, -53.000000) translate(670.184900, 53.789400)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#368FEF",
    d: "M3.728 5.678L14.782 5.678 14.782 0 12.939 2.567 9.466 0 6.658 2.567 3.728 0z",
    transform: "translate(-670.000000, -53.000000) translate(670.184900, 53.789400)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#368FEF",
    strokeWidth: 0.5,
    d: "M3.728 5.678L14.782 5.678 14.782 0 12.939 2.567 9.466 0 6.658 2.567 3.728 0z",
    transform: "translate(-670.000000, -53.000000) translate(670.184900, 53.789400)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightDomainAdmin);
export default __webpack_public_path__ + "static/media/light_domain_admin.9dfa2a3e1b43da5785c50931b321a251.svg";
export { ForwardRef as ReactComponent };